import * as React from "react";
import * as ReactDOM from "react-dom";

import { Goal, Hint, HintedSuitedNumber, Suit, SuitedNumber } from "./common";
import { Hand } from "./components/Hand";
import { Player } from "./components/Player";

ReactDOM.render(
  <div>
    <Player
      name="Anna"
      isCommander={true}
      goals={[new Goal(new SuitedNumber(Suit.Green, 7))]}
      hinted={
        new HintedSuitedNumber(new SuitedNumber(Suit.Blue, 7), Hint.Highest)
      }
    />
    <Player
      name="Dan"
      isCommander={false}
      goals={[new Goal(new SuitedNumber(Suit.Green, 1))]}
      hinted={false}
    />
    <Player name="Tammy" isCommander={false} goals={[]} hinted={true} />
    <Hand
      cards={[
        new SuitedNumber(Suit.Blue, 5),
        new SuitedNumber(Suit.Blue, 6),
        new SuitedNumber(Suit.Blue, 8),
        new SuitedNumber(Suit.Yellow, 2),
        new SuitedNumber(Suit.Green, 1),
        new SuitedNumber(Suit.Green, 3),
        new SuitedNumber(Suit.Rockets, 3)
      ]}
    />
  </div>,
  document.getElementById("container")
);
